/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
'use client';
import React, { useState } from 'react';
import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface ListProps {
  children: React.ReactNode;
  listItems: {
    title: string;
    text: string;
  }[];
}

const List = ({ children, listItems }: ListProps) => {
  const [expandedItemIdx, setExpandedItemIdx] = useState<number | undefined>(0);

  const handleSelectItem = (idx: number) => {
    if (expandedItemIdx === idx) {
      setExpandedItemIdx(undefined);
      return;
    }
    setExpandedItemIdx(idx);
  };

  return (
    <div className="flex flex-1 flex-col items-center gap-10 rounded-4xl p-10 shadow-card-dark-2">
      <h3 className="text-h4 flex self-start">{children}</h3>
      <div className="flex w-full flex-col gap-4">
        {listItems.map((item, idx) => {
          return (
            <div key={`${item.title}_${idx}`}>
              <div
                className={clsx(
                  'group flex cursor-pointer items-center justify-between',
                  idx === expandedItemIdx ? 'text-gradle-blue hover:text-gradle-blue' : 'text-gray-4 hover:text-white',
                )}
                onClick={() => {
                  handleSelectItem(idx);
                }}
              >
                <p className="text-eyebrow-strong">{item.title}</p>
                {idx === expandedItemIdx ? (
                  <MinusCircleIcon className="size-6 shrink-0" />
                ) : (
                  <PlusCircleIcon className="size-6 shrink-0" />
                )}
              </div>
              <div
                className={clsx(
                  'grid transition-all duration-300 ease-out',
                  idx === expandedItemIdx ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
                )}
              >
                <p className="text-body mr-6 overflow-hidden text-gray-4">{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
